<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>公司动态</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="number_main">
            <p class="toptitle">数据压缩存储成为“数字中国”亮点 </p>
            <p class="toptitle">智能庭审系统备受行业瞩目</p>
            <p class="con_p" style="margin-top: 60px;"> 在刚刚结束的第二届数字中国建设峰会上，“大数据”成为关键热词。在分论坛及相关成果展出的峰会现场，借助大数据的技术处理能力，越来越多的生产、生活场景呈现出了智能化的发展趋势。</p>
            <p class="con_p">在本次峰会上，以大数据智能应用为特点的产品纷纷亮相，应用新的计算模式，基于更加强大的数据管理能力，让我们看到了未来数字中国领先的数据分析力与信息洞察力，这将为行业发展的智能决策与流程优化带来新的发展机遇。</p>
            <img src="../../../assets/images/154.png" alt="" style="margin-bottom: 5px;">
            <p class="bottom-mid">(第二届数字中国建设峰会)</p>
            
            <p style="font-size: 18px; margin-top: 40px;">目前，国内大数据的发展呈现以下几大趋势：</p>
            <p style="font-weight: 700; margin-top: 23px;">大数据整体发展带来数据激增</p>
            <p class="con_p">随着数字中国建设的不断深入，海量数据呈现指数级的高速增长趋势。依据IDC相关数据，在刚刚过去的2018年，中国数据圈占全球数据圈的比例达到23.4%，即7.6ZB；预计到2025年将增至48.6ZB，占全球数据圈的27.8%，中国将成为全球最大的数据中心。</p>
            <p style="font-weight: 700; margin-top: 23px;">视频大数据管理成为关注重点</p>
            <p class="con_p">由于视频数据具有非结构化、体量庞大等特点，在大数据时代，如何对其进行有效管理，成为峰会的重点关注。在我国，目前，一个中等城市部署的视频监控摄像头，每天会基于3万路的高清视频设备产生大量新增数据，仅30天，其存储容量就可达36PB，这相当于36864块1TB硬盘的容量。由于这些视频数据需要长期保存，所以，就带来了冗余度高，占用空间大的管理难题。在这样的形势下，视频数据的无损压缩技术，得到了广泛的关注。</p>
            <p style="font-weight: 700; margin-top: 23px;">视频压缩技术解决视频管理难题</p>
            <p class="con_p">在本次数字中国建设峰会上，司马大大(北京)智能系统有限公司（以下简称“司马大大”）携手战略合作伙伴共同亮相，不仅最新发布的司法行业“智能庭审视频数据冷存储+解决方案”备受瞩目，其大数据长期存储在其他行业的应用案例也受到与会人员的热情追捧。</p>
            <img src="../../../assets/images/155.png" alt="" class="img-main">
            <div class="box-text">
                <p>智能庭审视频数据冷存储+解决方案</p>
            </div>
            <p class="con_p">智能庭审视频数据“冷存储+” 系统是可以满足大案要案审理的大型司法应用系统，在数字审判的过程中，该系统可提供更加清晰的视频图像、提供更加完美的声音录制服务。同时，能够保证生产数据的信息技术安全，从而实现对审理全过程、全范围的监控和管理。</p>
            <p>该系统引入自主创新的视频编解码技术，融合多种AI算法，在编解码过程中，形成独特的技术方案。在保证数字审判衍生视频数据画质的基础上，可实现高清视频10倍以上的无损压缩，降低视频传输和存储的压力，解决了司法行业视频媒资管理高成本、高投入的行业痛点。</p>
            <p>同时，系统依托“冷”“热”“温”数据分离技术的技术理念，整合蓝光光盘、闪盘、硬盘存储各自的优势，在实现数字法庭衍生视频数据平均10倍压缩效果的基础上，通过虚拟化技术满足了法院行业视频媒资数据海量、长期、安全、高效、绿色存储的需求。</p>
            <div class="box-text">
                <p>无损压缩技术</p>
            </div>
            <p class="con_p">自成立以来，司马大大依托视频压缩视觉处理技术已经完成多次产品迭代。其自主可控的视频编解码技术利用人工智能算法可对视频数据进行压缩，减少数据冗余，在不改变视频分辨率、帧率、视频时长无损压缩的前提下，与原视频压缩比最高可达20倍。基于自主创新视频编解码技术实现的视频管理系统VDMS（Video Data Management System）已经成功落地公安、交通、医疗、教育等行业，并为各类用户提供了视频实时压缩、低码流无线传输和视频溯源等高端技术服务，大大地缓解了这些行业视频存储的压力。</p>
            <p>另据官方介绍，本次展会总面积将近60000平方米，共分为综合+数字福建展区，主宾省+数字政府展区，数字经济展区(数字产业化)、数字经济展区(产业数字化)、智慧社会+数字生活+成果发布区等五大展区。峰会期间，共有156家企业发布和展出新技术及黑科技产品，给到场来宾带来一场汇聚数字中国前沿趋势的科技盛宴。</p>
            <img src="../../../assets/images/156.png" alt="" class="numimg_botttom" style="margin-top: 56px;">

        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }
 

/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.number_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 60px;
}

.number_main .toptitle {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
}

.number_main .con_p {
    font-size: 14px;
    text-indent: 2em;
}
.number_main img{
    display: block;
    margin: 0 auto;
    margin-top: 26px;
}

/* 括号中的字 */
.bottom-mid {
    font-size: 12px;
    color: #333;
    margin: 0 auto;
    text-align: center;
    margin-top: 10px;
}

/* 图片下方框里的字 */
.box-text {
    width: 520px;
    height: 82px;
    border: 3px dashed #4472C4;
    margin:  0 auto;
    padding: 20px;
    margin-top: 70px;
    margin-bottom: 65px;
}
.number_main .box-text p {
    font-size: 26px;
    font-weight: normal;
    text-align: center;
}

.img-main {
    width: 635px;
    height: 477px;
    margin-bottom: 0px;
    border: 3px solid #4472C4;
}

</style>



// WEBPACK FOOTER //
// src/components/news/light/light.vue